import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateCandidate,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [user, setUser] = useState([]);

  useEffect(() => {
    if (select_data) {
      setUpdate_modal_data({
        ...select_data,
        status: select_data.status || "",
        approved: select_data.approved || "",
        progress: select_data.progress || "",
        userId: select_data.userId ? select_data.userId._id : "",
        comments: select_data.comments || "",
        email: select_data.email || "",
        resume: null,
      });
    }
  }, [select_data]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "resume") {
      setUpdate_modal_data((prev) => ({
        ...prev,
        resume: files?.[0] || null,
      }));
      return;
    }

    setUpdate_modal_data((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateFields = () => {
    const newErrors = {};

    if (!update_modal_data.status) {
      newErrors.status = "Status is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!validateFields()) {
      Swal.fire("Please fill in all required fields", "", "error");
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to take this action?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { candidateId } = update_modal_data;
          if (!candidateId) {
            throw new Error("ID is not defined");
          }

          // Create a new FormData object
          const formData = new FormData();
          formData.append("status", update_modal_data.status);
          formData.append("approved", update_modal_data.approved);
          // formData.append("userId", update_modal_data.userId);
          if (update_modal_data.userId) {
            formData.append("userId", update_modal_data.userId);
          }

          formData.append("comments", update_modal_data.comments);

          const res = await axios.put(
            `${process.env.REACT_APP_BASE_URL}/api/v1/applicants/${candidateId}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            },
          );

          if (res.data.success) {
            Swal.fire("Update success", "", "success");
            onUpdateCandidate(update_modal_data);
            setRen(!ren);
          }
        } catch (error) {
          Swal.fire("Update failed", "", "error");
          console.error("Error updating job:", error);
        }
        set_update_data_modal_Show(false);
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }

        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        // ✅ Only ACTIVE SUPERVISORS
        const supervisors = response.data.users.filter(
          (user) =>
            user?.id_generalStaffType?.name === "Supervisor" &&
            user?.status === "Active",
        );

        setUser(supervisors);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUser([]);
      }
    };

    fetchUsers();
  }, []);

  const handleUserChange = (e) => {
    const { value } = e.target;

    setUpdate_modal_data((prevFormData) => ({
      ...prevFormData,
      userId: value, // ✅ now correctly captured
    }));
  };

  return (
    <>
      <Modal show={add_data_modal_Show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Applicant Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Control
                as="select"
                name="status"
                value={update_modal_data.status || ""}
                onChange={handleChange}
                isInvalid={!!errors.status}
              >
                <option value="">Select Status</option>
                <option value="Pending">Pending</option>

                <option value="In-Progress">In-Progress</option>
                <option value="Hired">Hired</option>
                <option value="Rejected">Rejected</option>
                <option value="Closed">Closed</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.status}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Assign Supervisor / Reporting Manager</Form.Label>
              <Form.Control
                as="select"
                name="userId"
                value={update_modal_data.userId || ""}
                onChange={handleUserChange}
                isInvalid={!!errors.userId}
              >
                <option value="">Select Users</option>
                {user.map((user) => (
                  <option key={user._id} value={user._id}>
                    {user.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Approved</Form.Label>
              <Form.Control
                as="select"
                name="approved"
                value={update_modal_data.approved || ""}
                onChange={handleChange}
                isInvalid={!!errors.approved}
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.approved}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Comments</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="comments"
                value={update_modal_data.comments || ""}
                onChange={handleChange}
                isInvalid={!!errors.comments}
              />
              <Form.Control.Feedback type="invalid">
                {errors.comments}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            className="btn btn-sm"
            onClick={handleUpdate}
          >
            Update Data
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
